<!-- CONTENIDO PARA HISTORIAL -->
<div class="modal">
    <a class="close" (click)="close()">Cerrar</a>
    <h1>Historial</h1>

    <div class="historial">
        <div class="customTable historial">
            <div class="header">
                <!-- @for( header of headers; track header){ -->
                <div class="cell usuario">Usuario</div>
                <div class="cell fechaYHora">Fecha y hora</div>
                <div class="cell accion">Acción</div>
                <div class="cell comentario">Comentario</div>

                <!-- } -->
            </div>
            @for( record of data;track record){
            <div class="row">
                <!-- @for( key of field ;track key){ -->
                <div class="cell usuario">{{record.userName}}</div>
                <div class="cell fechaYHora">{{format(record.updatedDate)}}</div>
                <div class="cell accion">
                    <div *ngIf="record.action == statusHistory.approved">Aprobada</div>
                    <div *ngIf="record.action == statusHistory.rejected">Rechazada</div>
                    <div *ngIf="record.action == statusHistory.draft">Borrador</div>
                    <div *ngIf="record.action == statusHistory.draft">En aprobación</div>
                    <div *ngIf="record.action == statusHistory.created">Creación</div>
                    <div *ngIf="record.action == statusHistory.modified">Modificación</div>
                </div>

                <div class="cell comentario">{{record.comments}}</div>
                <!-- } -->
            </div>
            }

        </div>

        <!-- Acciones para modal  -->
        <div class="actions">
            <div class="wrapper">
                <button type="submit" class="primary" (click)="close()">Aceptar</button>
            </div>
        </div>
    </div>
</div>
